import React from "react";
import { Tag, Button, Input, Card, Skeleton, Select, Drawer, Spin } from "antd";
import {
  PhoneOutlined,
  ClockCircleOutlined,
  SearchOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { CloseSquareFilled } from "@ant-design/icons";
import Scrollbars from "react-custom-scrollbars";
import dayjs from "dayjs";
import CustomerSearch from "../../../assets/images/search.png";
import CustomerIcon from "../../../assets/images/userId.svg";
import View from "../../../assets/images/view.svg";
import AddUser from "../../../assets/images/userAdd.svg";
import DefaultProductImage from "../../../assets/images/no-image.svg";
import BackIcon from "../../../assets/images/backIcon.svg";
import SearchIcon from "../../../assets/images/searchIcon.svg";
import POSLogo from "../../../assets/images/NewLogoCW.svg";
import LockIcon from "../../../assets/images/lock-icon.svg";
import userIcon from "../../../assets/images/userId.svg";

/**
 * The call center landing page (when callCenterVisible is false).
 * Shows header, held calls, and search input.
 */
export const CallCenterLandingPanel = ({
  holdQueue,
  resumeHoldCall,
  setShowCallCenterPage,
  setDisplayCustomerSearch,
  setShowProducts,
  setIsCallCenterFlow,
  tillValue,
  history,
}) => (
  <div
    style={{
      height: "100vh",
      display: "flex",
      flexDirection: "column",
      background: "#f3f4f9",
      fontFamily: "Inter",
    }}
  >
    {/* ---- Header ---- */}
    <div
      style={{
        backgroundColor: "#fff",
        borderRadius: "8px",
        padding: "6px 12px",
        margin: "12px 12px 0",
        boxShadow: "0 1px 3px rgba(0,0,0,0.1)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        border: "1px solid #f4f3f4",
      }}
    >
      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <img
          src={BackIcon}
          alt="Back"
          style={{ height: "24px", cursor: "pointer" }}
          onClick={() => {
            setShowCallCenterPage(false);
            history.push("/pos");
          }}
        />
        <img src={POSLogo} alt="POS Logo" style={{ height: "32px", cursor: "pointer" }} onClick={() => history.push("/pos")} />
        <span
          style={{
            fontFamily: "Inter",
            fontWeight: 600,
            fontSize: "1.5em",
            color: "#0F0718",
            marginLeft: "0.2vw",
            borderRadius: "2px",
            marginTop: "0.45rem",
          }}
        >
          Call Center
        </span>
      </div>

      <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
        <span style={{ fontSize: "12px", color: "#929098" }}>
          {new Date().toLocaleTimeString()} |{" "}
          {new Date().toLocaleDateString("en-US", {
            weekday: "long",
            day: "numeric",
            month: "long",
            year: "numeric",
          })}
        </span>
        <div>
          <img src={LockIcon} style={{ height: "20px", cursor: "pointer" }} alt="Lock" />
        </div>
        <div>
          <div
            style={{
              border: "1px solid #4b5563",
              borderRadius: "50%",
              padding: "4px",
            }}
          >
            <img src={userIcon} style={{ height: "20px" }} alt="User" />
          </div>
        </div>
        <div>
          <div style={{ display: "flex", flexDirection: "column" }}>
            <span style={{ fontSize: "12px", fontWeight: 500 }}>
              {(() => { try { const { useAuthStore } = require("../../../stores/useAuthStore"); return useAuthStore?.getState?.()?.userData?.user; } catch { return ""; } })()}
            </span>
            <span style={{ fontSize: "10px", color: "#6b7280" }}>Till ID: {tillValue?.name}</span>
          </div>
        </div>
        <div style={{ color: "#d00", fontWeight: 600, marginLeft: "10px" }}>{holdQueue?.length} Waiting</div>
      </div>
    </div>

    {/* ---- Calls on Hold Summary ---- */}
    <div
      style={{
        display: "flex",
        flexWrap: "wrap",
        gap: 12,
        padding: "16px 20px 8px",
        maxHeight: "35vh",
        overflowY: "auto",
      }}
    >
      {holdQueue.map((c) => (
        <Card
          key={c.id}
          size="small"
          style={{
            width: 200,
            height: 120,
            borderRadius: 8,
            background: "#fff",
            boxShadow: "0 1px 3px rgba(0,0,0,0.05)",
            border: "1px solid #e9e8ea",
            position: "relative",
            flex: "0 0 auto",
            padding: "8px",
            display: "flex",
            flexDirection: "column",
            justifyContent: "space-between",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 4,
            }}
          >
            <div
              title={c.name}
              style={{
                fontWeight: 600,
                fontSize: 14,
                color: "#0F0718",
                maxWidth: 100,
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
              }}
            >
              {c.name}
            </div>
            <div style={{ fontSize: 12, color: "#d00", flexShrink: 0 }}>
              <ClockCircleOutlined /> {c.aht}
            </div>
          </div>

          <div style={{ fontSize: 12, color: "#929098", marginBottom: 8 }}>{c.phone}</div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            <div
              style={{
                backgroundColor: "#fff9e6",
                border: "1px solid #ffe58f",
                color: "#b38b00",
                fontSize: 11,
                fontWeight: 600,
                padding: "2px 8px",
                borderRadius: "7px",
              }}
            >
              On Hold
            </div>
            <Button
              type="default"
              size="small"
              style={{
                fontSize: 11,
                height: 24,
                padding: "0 8px",
                backgroundColor: "#e6f9e6",
                border: "1px solid #28a745",
                color: "#0F0718",
                fontWeight: 500,
                borderRadius: "7px",
              }}
              onClick={(e) => {
                e.stopPropagation();
                resumeHoldCall(c);
              }}
            >
              Retrieve
            </Button>
          </div>
        </Card>
      ))}
    </div>

    {/* ---- Search + Sort ---- */}
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        padding: "8px 20px",
      }}
    >
      <Input
        placeholder="Search for customer by phone, name..."
        prefix={<SearchOutlined style={{ color: "#929098" }} />}
        style={{
          width: "60%",
          height: 32,
          fontSize: 13,
          borderRadius: 6,
          border: "1px solid #92909880",
          marginTop: "2vw",
        }}
        allowClear
        onFocus={() => {
          setDisplayCustomerSearch(true);
          setShowProducts(false);
          setIsCallCenterFlow(true);
        }}
      />
    </div>
  </div>
);

/**
 * Store selection drawer component.
 */
export const StoreSelectionDrawer = ({
  storeModalVisible,
  setStoreModalVisible,
  retailStores,
  setRetailStores,
  selectedStore,
  setSelectedStore,
  setCart,
}) => (
  <Drawer
    title={<span style={{ fontSize: "20px", color: "#0F0718", fontWeight: 600 }}>Select Store</span>}
    placement="right"
    width={380}
    onClose={() => setStoreModalVisible(false)}
    open={storeModalVisible}
    styles={{ body: { padding: "0.5rem", paddingTop: 0, background: "white" } }}
    closeIcon={<span style={{ color: "#0F0718", fontSize: "20px" }}>×</span>}
  >
    <div style={{ padding: "12px" }}>
      <Input
        placeholder="Search store"
        prefix={<SearchOutlined style={{ color: "#929098" }} />}
        style={{ marginBottom: 12 }}
        allowClear
        onChange={(e) => {
          const term = e.target.value.toLowerCase();
          setRetailStores((prev) =>
            prev.filter((s) => s.name.toLowerCase().includes(term) || s.value.toLowerCase().includes(term) || (s.address && s.address.toLowerCase().includes(term)))
          );
        }}
      />

      <div
        style={{
          display: "grid",
          gap: "12px",
          gridTemplateColumns: "1fr",
          maxHeight: "calc(100vh - 150px)",
          overflowY: "auto",
        }}
      >
        {retailStores.map((store) => (
          <Card
            key={store.value}
            hoverable
            style={{
              cursor: "pointer",
              borderRadius: 8,
              background: selectedStore?.value === store.value ? "#eff6ff" : "#fff",
            }}
            onClick={() => {
              setSelectedStore(store);
              setCart((prev) => ({ ...prev, selectedStore: store }));
              setStoreModalVisible(false);
              require("antd").message.success(`Store changed to: ${store.name}`);
            }}
          >
            <div style={{ fontWeight: 600, fontSize: 15 }}>{store.name}</div>
            <div style={{ fontSize: 12, color: "#929098" }}>{store.address || store.value}</div>
          </Card>
        ))}
      </div>
    </div>
  </Drawer>
);

export default { CallCenterLandingPanel, StoreSelectionDrawer };
